import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faFacebookMessenger, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { connect, useSelector } from 'react-redux';
import { reset as resetForm } from 'redux-form';
import { reset } from '../../redux/actions/Coberturas';
import '../../sass/FinalPedido.scss';

const FinalPedido = ({ resetReservacion, resetDataCliente }) => {

    const enlaces = useSelector(state => state.enlaces);
    const puntosContacto = useSelector(state => state.puntosContacto);
    window.scrollTo(0, 0);

    return (
        <>
            <div id="show_bg_2"></div>
            <div className="container-form">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>GRACIAS POR PREFERIRNOS</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: "15px" }}></div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                En breve recibirás un correo electrónico con los datos de tu reserva.
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: "20px" }}></div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                Para mayor información puedes comunicarte con nosotros por
                                medio de <a id="link-contacto" href="#ContactosModal" data-toggle="modal" data-target="#ContactosModal">Contáctanos</a> o través de los siguientes teléfonos o
                                enlaces.
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: "40px" }}></div>
                        </div>
                        <div className="row">
                            {
                                puntosContacto.find(w => w.Id === "RES") &&
                                <div className="col-lg-6 ">
                                    <div className="row">
                                        <div className="col-auto">
                                            <h3 className="subtitle">{puntosContacto.find(w => w.Id === "RES").Nombre}</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-auto">
                                            <p style={{ color: '#373737' }}>
                                                Teléfono: {puntosContacto.find(w => w.Id === "RES").Telefono} <br />
                                                {puntosContacto.find(w => w.Id === "RES").Correo}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                puntosContacto.find(w => w.Id === "ATC") &&
                                <div className="col-lg-6 ">
                                    <div className="row">
                                        <div className="col-auto">
                                            <h3 className="subtitle">{puntosContacto.find(w => w.Id === "ATC").Nombre}</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-auto">
                                            <p style={{ color: '#373737' }}>
                                                Teléfono: {puntosContacto.find(w => w.Id === "ATC").Telefono} <br />
                                                {puntosContacto.find(w => w.Id === "ATC").Correo}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: "30px" }}></div>
                        </div>
                        <div className="row">
                            <div className="col-auto">
                                <h3 className="subtitle">Encuéntranos en:</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-auto social-media">
                                <a href={enlaces.find(w => w.Id === "FACEBOOK")?.URL === undefined ? "#" :  enlaces.find(w => w.Id === "FACEBOOK")?.URL} className="icon-facebook"><i><FontAwesomeIcon icon={faFacebookF} /></i></a>
                                <a href={enlaces.find(w => w.Id === "MESSENGER")?.URL === undefined ? "#" :  enlaces.find(w => w.Id === "MESSENGER")?.URL} className="icon-messenger"><i><FontAwesomeIcon icon={faFacebookMessenger} /></i></a>
                                <a href={enlaces.find(w => w.Id === "WHATSAPP")?.URL === undefined ? "#" :  enlaces.find(w => w.Id === "WHATSAPP")?.URL} className="icon-whatsapp"><i><FontAwesomeIcon icon={faWhatsapp} /></i></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: "30px" }}></div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <button onClick={() => {
                                    resetReservacion();
                                    resetDataCliente();
                                    window.scrollTo(0, 0);
                                }} className="btn btn-interamerican">REGRESAR AL INICIO</button>
                            </div>
                        </div>
                    </div>
                    <div className="com-lg-8"></div>
                </div>
            </div>
        </>
    )
}

const mapDispatchToProps = dispatch => ({
    resetReservacion: () => dispatch(reset()),
    resetDataCliente: () => dispatch(resetForm("FormDataCliente")),
})

export default connect(null, mapDispatchToProps)(FinalPedido)
